/*
 * SPDX-FileCopyrightText: 2020-2023 CERN.
 * SPDX-FileCopyrightText: 2020-2022 Northwestern University.
 * SPDX-License-Identifier: MIT
 */
export const emptyReference = {
  reference: "", // note: this refers to reference.reference and not the object
};
